// extracted by mini-css-extract-plugin
export default {"spinner":"PublicationStatusRedirect_spinner__4-bFN"};